import { createSelector } from '@reduxjs/toolkit';
import { isSuburban } from '../../../../packages/JsonQuery';
import { selectOfferType } from 'shared/selectors/jsonQuery';

export const selectConstructionTypeLabel = createSelector(selectOfferType, offerType =>
  isSuburban(offerType) ? 'Материал дома' : 'Тип дома',
);
